module.exports = __webpack_public_path__ + "static/media/edit_component.c04322f7.gif";